<template>
 <div class="cont app-container">
    <div class="left"    v-loading="loading">
       <div class="inpbox">
          <el-select   v-model="teamOrgId" filterable placeholder="请选择" clearable  size="mini" >
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
           <el-input placeholder="" v-model="vehNo"  size="mini"></el-input>
       </div>
        <div class="inpbox">
            <el-button type="primary" @click="searchFn">查询</el-button>
           <el-button type="primary" @click="chongzhiFn">重置</el-button>
        </div>
       <hr>

       <div class="treeBox" ref="treeRef">
        <el-tree
          :data="datatree"
          show-checkbox
          node-key="code"
          ref="tree"
          :props=props
           @check="treecheck"
           default-expand-all
          :check-on-click-node="true"
           :render-content="renderContent"
          >
        </el-tree>
      </div>
      <div class="btnBox"> <el-button type="primary" @click="searchGps">查询</el-button></div>
    </div>
    <div class="right">
      <div class="map" >
        <div id="map"></div>
        <div class="ztBox">
          <div class="ztBoxItme" style="border-right:1px  solid rgb(170, 167, 167);">
            <h6>车辆状态</h6>
            <div class="boxA">
              <div class="boxAitme">
                <p  class="red" style="font-size: 16px;text-align: center;">{{ json.totalCount }}</p>
                <p>车辆总数</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center; color: #F98046;">{{ json.workingCount}}</p>
                <p>作业中</p>
              </div>
              <div class="boxAitme">
                <p  class="red" style="font-size: 16px;text-align: center;">{{ json.maintainingCount }}</p>
                <p>维修中</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center;color: #1093EC;">{{ json.chargingCount }}</p>
                <p>充电中</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center;color: #04A527;">{{ json.idleCount }}</p>
                <p>空闲</p>
              </div>
            </div>
          </div>
          <div class="ztBoxItme">
            <h6>司机状态</h6>
            <div class="boxA">
              <div class="boxAitme">
                <p  class="red" style="font-size: 16px;text-align: center;">{{ jsonSJ.totalCount }}</p>
                <p>司机总数</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center;color: #F98046;">{{ jsonSJ.workingCount }}</p>
                <p>作业中</p>
              </div>
              <div class="boxAitme">
                <p  class="red" style="font-size: 16px;text-align: center;">{{ jsonSJ.toWorkCount }}</p>
                <p>待作业</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center;color: #04A527;">{{ jsonSJ.offWorkCount }}</p>
                <p>已下线</p>
              </div>
              <div class="boxAitme">
                <p class="red" style="font-size: 16px;text-align: center; color:#797979;">{{ jsonSJ.onLeaveCount }}</p>
                <p>休假中</p>
              </div>
            </div>
          </div>
        </div>
        <div class="detail" v-if="isDetail">
           <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="行驶信息" name="gps" v-if="vehGps">
              <div class="box1">
                 <div class="item"><span class="name">车牌号：</span><span>{{vehGps.plain}}</span></div>
                 <div class="item"><span  class="name">行驶状态：</span><span>{{vehGps.status}}</span></div>
                 <div class="item"><span  class="name">当前速度：</span><span v-if="vehGps.speed!='null'">{{vehGps.speed}}KM/H</span></div>
                 <div class="item"><span  class="name" v-if="vehGps.fx">当前方向：</span><span> {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][vehGps.fx-1]}}</span></div>
                 <div class="item"><span  class="name">总计里程：</span><span>{{vehGps.mileage}}KM</span></div>
                 <div class="item"><span  class="name">设备ID：</span><span>{{vehGps.terminal_code}}</span></div>
                 <div class="item"><span  class="name">SIM卡号：</span><span>{{vehGps.sim}}</span></div>
                 <div class="item"><span  class="name">经度：</span><span>{{vehGps.longitude}}</span></div>
                 <div class="item"><span  class="name">纬度：</span><span>{{vehGps.latitude}}</span></div>
                  <div class="item item1"><span  class="name">上报时间：</span><span>{{vehGps.gps_time}}</span></div>
                 <div class="item item1"><span  class="name">当前位置：</span><span>{{vehGps.address}}</span></div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="车辆信息" name="veh">
              <div class="box1">
                <div class="item"><span class="name">车牌号：</span><span>{{vehInfo.vhcNo}}</span></div>
                 <div class="item"><span  class="name">车辆类型：</span><span>{{vehInfo.vhcTypeName}}</span></div>
                 <div class="item"><span  class="name">车辆用途：</span><span>{{vehInfo.purposeName}}</span></div>
                 <div class="item"><span  class="name">所属单位：</span><span>{{vehInfo.vhcCompanyName}}</span></div>
                 <div class="item"><span  class="name">能源类型：</span><span>{{["其他","******", "汽油","柴油", "气", "电"  ][vehInfo.energyType+1]}}</span></div>
                  <div class="item"><span  class="name">载重(吨)：</span><span>{{vehInfo.weight}}</span></div>
                 <div class="item"><span  class="name">行驶证号：</span><span>{{vehInfo.drivingLicense}}</span></div>
                 <div class="item"><span  class="name">车架号：</span><span>{{vehInfo.vhcVinNo}}</span></div>
                 <div class="item"><span  class="name">发动机号：</span><span>{{vehInfo.vhcEngineNo}}</span></div>
                 <div class="item"><span  class="name">注册日期：</span><span>{{vehInfo.registerDate}}</span></div>
              </div>
            </el-tab-pane> -->
          </el-tabs>
          <div class="close" @click="closeFn"><i class="el-icon-close"></i></div>
        </div>
        <!-- <div class="tuli">
          <div class="box2">
            <div class="item"><img src="../../../assets/vehMonitor/xingshi.png"><span>行驶</span></div>
            <div  class="item"><img src="../../../assets/vehMonitor/tingche.png"><span>停车</span></div>
          </div>
        </div> -->
      </div>
      <div class="tbale" v-if="false">
        <el-table :data="vehList"  ref="vehList" height="100%"    highlight-current-row  @current-change="handleCurrentChange" border >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column prop="plain" width="120"  label="车牌号"></el-table-column>
        <el-table-column prop="gps_time" width="170" label="上报时间"></el-table-column>
        <el-table-column prop="status" width="120" label="行驶状态"></el-table-column>
         <!-- <el-table-column property="fx" width="100" label="是否异常" >
          <template scope="scope">
            {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][scope.row.fx-1]}}
          </template>
        </el-table-column> -->
        <el-table-column prop="address"  min-width="260" :show-overflow-tooltip="true" label="当前位置"></el-table-column>
        <el-table-column  prop="speed" width="140" label="速度(KM/H)" ></el-table-column>
        <el-table-column property="fx" width="100" label="当前方向" >
          <template scope="scope">
            {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][scope.row.fx-1]}}
          </template>
        </el-table-column>
        <el-table-column  prop="terminal_code" width="100" label="设备ID" ></el-table-column>
        <el-table-column  prop="sim" width="120" label="SIM卡号" ></el-table-column>
        <el-table-column  prop="longitude" width="120" :show-overflow-tooltip="true" label="经度" ></el-table-column>
        <el-table-column  prop="latitude" width="120" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
      </el-table>
      </div>
    </div>
 </div>
</template>

<script>
import { direction } from '@/utils/util'
import AMap from 'AMap'
import { orgTree, vehiclePositionInfo, driverVehicleStatus, organizationTree } from '@/api/vgs-driver2.0'
import { realTimeTrajectory } from '@/api/vehMonitor'
export default {

  data () {
    return {
      isDetail: false,
      isVeh: true,
      isDri: false,
      datatree: [],
      props: {
        children: 'children',
        label: 'vhcNo'
      },
      vehList: [],
      activeName: 'gps',
      timer: null,
      map: null,
      markers: [],
      vehNo: '',
      teamOrgId: '',
      vehInfo: null,
      vehGps: null,
      loading: false,
      checkList: [],
      json: {},
      jsonSJ: {},
      DZid: '',
      XDList: []
    }
  },
  created () {
    this.getVehicleTree()
    driverVehicleStatus().then(res => {
      this.json = res.vehicleStatusStats
      this.jsonSJ = res.driverStatusStats
    })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    this.initMap()
    // this.timer = setInterval(() => {
    // cVehicleListGpsInfo({ vhcNoList: this.selectArr }).then(res => {
    //   let arr = []
    //   if (res) {
    //     res.forEach(item => {
    //       let json = JSON.parse(item)
    //       json.fx = direction(json.direction)
    //       if (json.longitude > 0 && json.latitude > 0) { arr.push(json) }
    //     })
    //     this.vehList = arr
    //     this.markerFn()
    //   }
    // })
    // }, this.global.mapTime.commonTime)
  },
  methods: {
    renderContent (h, { node, data, store }) {
      console.log(node)
      if (data.count) {
        return (
          <span class="custom-tree-node">
            <span>{data.name }</span>(<span style="color:red">{data.count}</span>)
          </span>)
      } else {
        if (data.vehicleStatus == '维修中') {
          return (
            <span class="custom-tree-node">
              <span>{data.name }</span><img style="width:15px" src='https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/weixiuzhong.png'></img>
            </span>)
        }
        if (data.vehicleStatus == '充电中') {
          return (
            <span class="custom-tree-node">
              <span>{data.name }</span><img style="width:15px" src='https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/chongdianzhong.png'></img>
            </span>)
        }
        if (data.vehicleStatus == '作业中') {
          return (
            <span class="custom-tree-node">
              <span>{data.name }</span><img style="width:15px" src='https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/gongzuozhong1.png'></img>
            </span>)
        }

        if (data.vehicleStatus == '空闲') {
          return (
            <span class="custom-tree-node">
              <span>{data.name }</span><img style="width:15px" src='https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/kongxian1.png'></img>
            </span>)
        }
      }
    },
    getVehicleTree () {
      this.loading = true
      let str = ''
      if (this.checkList.length == 1) {
        str = this.checkList[0]
      } else {
        str = ''
      }
      orgTree({ vhcNo: this.vehNo, teamOrgId: this.teamOrgId }).then(res => {
        if (res.length > 0) {
          this.datatree = res
        } else {
          this.datatree = []
        }

        this.loading = false
      })
    },
    searchFn () {
      this.getVehicleTree()
    },
    chongzhiFn () {
      this.vehNo = ''
      this.teamOrgId = ''
      this.getVehicleTree()
    },
    geVhetList (data) {
      this.vehList = []
      let that = this
      let Sarr = null
      let n = 0
      if (data.vhcNoList) {
        Sarr = sliceArr(data.vhcNoList, 500)
        getGpsInfo()
      }
      function getGpsInfo () {
        // cVehicleListGpsInfo({ vhcNoList: Sarr[n] }).then(res => {
        //   n++
        //   if (res) {
        //     res.forEach(item => {
        //       let json = JSON.parse(item)
        //       json.fx = direction(json.direction)
        //       if (json.longitude > 0 && json.latitude > 0) { that.vehList.push(json) }
        //     })
        //     that.markerFn()
        //   }
        //   if (n < Sarr.length) {
        //     getGpsInfo()
        //   }
        // })
      }
      function sliceArr (arr, len) {
        let n = arr.length
        let newArr = []
        for (let i = 0; i < n; i += len) {
          newArr.push(arr.slice(i, i + len))
        }
        return newArr
      }
    },
    treecheck () {
      let checkArr = this.$refs.tree.getCheckedNodes(true)
      this.selectArr = checkArr
    },
    searchGps () {
      this.vehList = []
      let vho = []
      this.selectArr.forEach(item => {
        let licensePlateColor = item.noColourCode == 7 ? 3 : item.noColourCode
        vho.push({ vhcNo: item.name, licensePlateColor: licensePlateColor })
      })
      if (vho.length === 0) return
      const loading = this.$loading({
        lock: true,
        text: '正在查询车辆定位...'
      })
      // 每个车牌号单独查一次接口
      let requests = vho.map(j => {
        return realTimeTrajectory({ plateNumber: j.vhcNo, licensePlateColor: j.licensePlateColor }).then(res => {
          // if (res && res.length > 0) {
          //   this.vehList = this.vehList.concat(res)
          // }
          if (res) {
            this.vehList.push(res)
          }
        }).catch(error => {
          let msg = (error && (error.msg || error.message)) || '查询失败'
          this.$message({
            showClose: true,
            message: j.vhcNo + '：' + msg,
            type: 'error'
          })
        })
      })
      Promise.all(requests).then(() => {
        loading.close()
        if (this.vehList.length > 0) {
          this.markerFn()
        } else {
          // this.$alert('暂未查到定位信息', '系统提示')
        }
      }).catch(() => {
        loading.close()
      })
    },
    getVehInfo () {
      // vehiclePositionInfo({ id: this.DZid }).then(res => {
      //   this.vehInfo = res
      // })
    },
    getVehGps () {
      vehiclePositionInfo({ vhcNo: this.DZid }).then(res => {
        this.vehGps = res
        this.vehGps.fx = direction(res.direction)
        console.log('this.vehGps', this.vehGps)
      })
    },
    handleClick () {
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      // this.markerFn()
      this.map.setFitView()
    },
    markerFn () {
      this.map.remove(this.markers)
      for (var i = 0; i < this.vehList.length; i += 1) {
        var marker
        let icon
        if (this.vehList[i].vehicleStatus == '维修中') {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/weixiuzhong.png',
            size: new AMap.Size(36, 36)
          })
        }
        if (this.vehList[i].vehicleStatus == '充电中') {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/chongdianzhong.png',
            size: new AMap.Size(36, 36)
          })
        }
        if (this.vehList[i].vehicleStatus == '工作中') {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/gongzuozhong.png',
            size: new AMap.Size(36, 36)
          })
        }
        if (this.vehList[i].vehicleStatus == '空闲') {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/kongxian.png',
            size: new AMap.Size(36, 36)
          })
        }
        let item = this.vehList[i]
        let position = [item.longitude, item.latitude]
        marker = new AMap.Marker({
          icon: icon,
          position: position,
          offset: new AMap.Pixel(0, 0),
          zIndex: 101,
          title: item.vhcNo || item.plain,
          id: item.vhcNo || item.plain,
          map: this.map
        })
        // 点击时直接把铺点用的数据传过去，不再二次请求接口
        marker.on('click', () => this.showInfoM(item))
        this.markers.push(marker)
      }
      this.map.setFitView()
    },
    showInfoM (item) {
      // 直接用铺点时接口返回的数据展示，不再请求接口
      if (!item) return
      this.DZid = item.vhcNo || item.plain
      this.vehGps = Object.assign({}, item)
      if (this.vehGps.direction) {
        this.vehGps.fx = direction(this.vehGps.direction)
      }
      this.isDetail = true
    },
    handleCurrentChange (val) {
      this.vehNo = val.plain
      this.getVehInfo()
      this.isDetail = true
    },
    closeFn () {
      this.isDetail = false
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>
<style scoped lang='less'>
.tuli{
  position: absolute;
  right: 0px;
  bottom: 0;
  background: #fff;
  z-index: 999999;
  border-radius: 10px 0px 0px 0px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box2{
    display: flex;
    .item{
      display: flex;
      width: 60px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      img{
        margin-bottom: 6px;
      }
    }
  }
  .hr{
    height: 26px;
    width: 0px;
    border-left:1px solid #ddd!important;
  }
}
.detail{
  position: absolute;
  right: 0px;
  bottom: 0;
  background: #fff;
  width: 400px;
  border-radius: 10px 0px 0px 0px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box1{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0c46a2;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  /deep/.el-tabs__item{
    font-size: 12px;
  }
  /deep/.el-tabs__nav{
    padding-left: 10px;
  }
  /deep/.el-tab-pane{
    padding: 0px 10px 15px;
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar{
    left: 10px;
  }
  .close{
    height: 40px;
    position:absolute;
    top:0;
    right: 20px;
    display: flex;
    align-items: center;
  }
}
/deep/.el-main{
  padding-top:0 !important;
}
.cont{
  display: flex;
}
.left{
  width: 300px;
  height: 100%;
  overflow: auto;
  flex-shrink: 0;
  background: #fff;
}
.right{
  flex: 1;
  height: 100%;
  width:calc(100% - 300px);
}
.tbale{
  height: 30%;
  font-size: 12px;
}
.map{
  height:100%;
  position: relative;
}
#map{
  width: 100%;
  height: 100%;
}
/deep/.el-tree-node__label{
  font-size: 12px;
}
.inpbox{
  position: relative;
  width: 90%;
  margin: 10px;
  text-align: right;
  display: flex;
}
/deep/.custom-tree-node{
  font-size: 12px;
}
.btnBox{
     position: absolute;
    text-align: center;
    width: 300px;
    bottom: 40px;
    padding-bottom: 20px;
    background: #fff;
}
.treeBox{
  padding-bottom: 50px;
}
.boxA{
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
  p{
    margin: 2px;
    font-size: 14px;
  }
}
.ztBox{
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .ztBoxItme{
    width: 50%;
    padding:0 10px;
  }
  h6{
    margin: 8px;
  }
}
/deep/.el-tree{
  height: 100%;
}
</style>
